import React from 'react';

import classNames from 'classnames';
import { InfoHelper } from 'src/components/InfoHelper';

import s from './CardKeyResultDefault.module.scss';
import { TCardKeyResultDefaultProps } from './CardKeyResultDefault.types';

export const CardKeyResultDefault: React.FC<TCardKeyResultDefaultProps> = ({
  value,
  symbol,
  symbolPosition,
  resultInfo,
  className,
  useTooltip = true,
}) => {
  const { title, description } = resultInfo;
  return (
    <div className={classNames(s.assetInfo, s.block, className)}>
      <header>
        <div className={s.earningStatus}>{title}</div>
        {useTooltip && <InfoHelper position="bottom" info={description} />}
      </header>
      <div className={s.cost}>
        <span>
          {symbolPosition === 'left' && symbol}
          {value}
          {symbolPosition === 'right' && symbol}
        </span>
      </div>
      {!useTooltip && <span className={s.description}>{description}</span>}
    </div>
  );
};
